import counterUp from 'counterup2';

function startCounterWhenVisible(entries, observer) {
    if (entries && entries.length) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                counterUp(entry.target, {
                    duration: 1000,
                    delay: 16,
                });
                observer.unobserve(entry.target);
            }
        });
    }
}

const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1 // Sobald 10% des Elements sichtbar sind, wird die Callback-Funktion ausgeführt
};

const el = document.querySelectorAll('.counter');

el.forEach(el => {
    const observer = new IntersectionObserver(startCounterWhenVisible, options);
    observer.observe(el);
});
